'use strict';

import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import Edit from '../../svgs/Edit.jsx';
import User from '../../svgs/User.jsx';

const AppNav = ({ location }) => (
  <nav>
    <NavLink location={ location } activeClassName="active" to="/projects"><span>{ Edit }</span><span>Projects</span></NavLink>
    <NavLink location={ location } activeClassName="active" to="/account"><span>{ User }</span><span>Account</span></NavLink>
  </nav>
);

export default withRouter(AppNav);



// WEBPACK FOOTER //
// ./src/components/utilities/AppNav.jsx